import { useEffect } from "react";
import { MapContainer, TileLayer, Polyline, Polygon, Marker, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pin = (n, active) =>
  L.divIcon({
    className: "",
    html: `<div class="survey-pin${active ? " survey-pin-active" : ""}">${n}</div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 13],
  });

function Fit({ points }) {
  const map = useMap();
  useEffect(() => {
    if (points.length) map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lon])).pad(0.25), { maxZoom: 19 });
  }, [map, points]);
  return null;
}

function Focus({ point }) {
  const map = useMap();
  useEffect(() => {
    if (point) map.panTo([point.lat, point.lon], { animate: true });
  }, [map, point]);
  return null;
}

export function SurveyMap({ survey, selected, onSelect }) {
  const sel = survey.points.find((p) => p.n === selected);
  return (
    <div className="relative z-0 isolate h-[420px] sm:h-[520px] border-2 border-black bg-[#0B0B0B]" data-testid="survey-map">
      <MapContainer center={[survey.points[0].lat, survey.points[0].lon]} zoom={17} maxZoom={20} className="h-full w-full" scrollWheelZoom>
        <TileLayer
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          className="survey-tiles"
          maxNativeZoom={19}
          maxZoom={20}
        />
        {survey.boundary.length >= 3 && (
          <Polygon positions={survey.boundary} pathOptions={{ color: "#FF2A2A", weight: 2, fillOpacity: 0.08, dashArray: "6 4" }} />
        )}
        {survey.path.length >= 2 && <Polyline positions={survey.path} pathOptions={{ color: "#00D4FF", weight: 3 }} />}
        {survey.points.map((p) => (
          <Marker key={p.id} position={[p.lat, p.lon]} icon={pin(p.n, p.n === selected)}
            eventHandlers={{ click: () => onSelect(p.n, true) }} />
        ))}
        <Fit points={survey.points} />
        <Focus point={sel} />
      </MapContainer>
    </div>
  );
}
